import { render, staticRenderFns } from "./loader-for-autoload.vue?vue&type=template&id=50a0eb39&scoped=true"
import script from "./loader-for-autoload.vue?vue&type=script&lang=js"
export * from "./loader-for-autoload.vue?vue&type=script&lang=js"
import style0 from "./loader-for-autoload.vue?vue&type=style&index=0&id=50a0eb39&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a0eb39",
  null
  
)

export default component.exports